// Runtime override (injected in public/index.html) -> build-time env -> fallback
const URLBASE =
  (typeof window !== 'undefined' && window.__APP_CONFIG__ && window.__APP_CONFIG__.BASE_URL) ||
  process.env.REACT_APP_BASE_URL ||
  require('./Ambiente.js').default;

export { URLBASE };
export const LOCALE = 'es-AR';
export const URLLOGIN = URLBASE + '/login';
export const URLLOGOUT = URLBASE + '/logout';

export const ORDEN_TECNICOS = 90;
